<template>
  <div class="offlineTimeoutReminder-container">
    <el-form inline size="medium" :model="queryForm" ref="queryForm" class="input-form-inline" @submit.native.prevent>
      <el-form-item class="r-20" prop="plateNum">
        <el-input v-model.trim="queryForm.plateNum" placeholder="请输入车牌号" @keyup.enter.native="query"></el-input>
      </el-form-item>
      <el-form-item class="r-20" prop="personnelName">
        <el-input v-model.trim="queryForm.personnelName" placeholder="请输入车辆绑定人" @keyup.enter.native="query"></el-input>
      </el-form-item>
      <el-form-item class="r-20" prop="deptIds">
        <el-cascader v-model="queryForm.deptIds" style="width: 260px" size="mini" placeholder="请选择使用公司" ref="cascader"
          :options="deptList" :props="{
            emitPath: true,
            multiple: true,
            checkStrictly: false,
            value: 'id',
            children: 'children',
            label: 'label',
          }" clearable collapse-tags>
        </el-cascader>
      </el-form-item>
      <el-form-item class="r-20" prop="propertyOwner">
        <el-input v-model.trim="queryForm.propertyOwner" placeholder="请输入产权方名称" @keyup.enter.native="query"></el-input>
      </el-form-item>
      <el-button type="primary" @click="query">查询</el-button>
      <el-button @click="resetForm">取消</el-button>
    </el-form>
    <el-row style="height:20px"></el-row>
    <div class="bottom">
      <el-table :loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
        size="mini" stripe height="560px">
        <el-table-column width="20"></el-table-column>
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="plateNum" label="车牌号" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="vin" label="车架号" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="personnelName" label="车辆绑定人" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName" label="所属使用公司" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="propertyOwner" min-width="120" label="所属产权方" show-overflow-tooltip></el-table-column>
        <el-table-column prop="lastShutdownTime" label="上次熄火时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="unstartDuration" label="未启动时长（天）" min-width="130" show-overflow-tooltip>
          <template slot="header">
            <span>未启动时长(天)</span>
            <span @click="noStartTimeSort" class="iconfont icon-sort"></span>
          </template>
        </el-table-column>
        <el-table-column prop="reminderFrequency" label="提醒次数" min-width="100" show-overflow-tooltip>
          <template slot="header">
            <span>提醒次数</span>
            <span @click="remindCountSort" class="iconfont icon-sort"></span>
          </template>
        </el-table-column>
        <el-table-column prop="lastReminderTime" min-width="160" label="最后一次提醒时间"
          show-overflow-tooltip></el-table-column>

        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click.stop="remindRecord(scope.row)"
              style="margin-left: 10px">提醒记录</el-button>
            <el-button size="mini" type="text" @click.stop="getLocation(scope.row)">位置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="limit"
        layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <!--提醒记录-->
    <el-dialog :title="plateNum" :visible.sync="remindVisible" class="remindDialog">
      <div class="table-wrapper">
        <!-- <div class="table-title">{{ plateNum }}</div>  -->
        <div class="table-body" v-for="item in remindData" :key="item.id">
          <div class="table-top">
            <span>{{ item.number }}</span>
            <span class="table-time">通知时间：{{ item.notificationTime }}</span>
          </div>
          <el-table :data="item.list" style="width: 100%" size="mini">
            <el-table-column prop="name" label="提醒姓名" min-width="140" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="account" label="账号" align="center" min-width="140"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="联系方式" align="center" min-width="140"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="amount1" label="提醒应用" align="center" min-width="140"
              show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </div>

      <!-- <el-table
        :data="remindData"
        style="width: 100%"
        size="mini"
        :span-method="objectSpanMethod"
      >
        <el-table-column
          type="index"
          width="60"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="plateNum"
          label="车牌号"
          align="center"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="notificationTime"
          label="提醒时间"
          min-width="140"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="name"
          label="提醒姓名"
          min-width="140"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="account"
          label="账号"
          align="center"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          align="center"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="amount1"
          label="提醒应用"
          align="center"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
      </el-table> -->
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="remindVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span> -->
    </el-dialog>
    <!--车辆定位-->
    <el-dialog title="车辆定位" :visible.sync="remindPositionVisible" @close="closeDialog">
      <div id="remindPosition"></div>
      <div class="time">
        <span class="refreshTime">{{ refreshTime }}</span>
        <el-button type="primary" @click="refreshOpenMap">刷新</el-button>
      </div>
      <div class="infoWindow" ref="vehicleInfo" v-show="showInfoWindow">
        <el-row>
          <el-row>
            <span>经度：</span>
            <span>{{ addressData.longitude }}</span>
          </el-row>
          <el-row>
            <span>纬度：</span>
            <span>{{ addressData.latitude }}</span>
          </el-row>
          <el-row>
            <span>详细地址：</span>
            <span>{{ addressData.address }}</span>
          </el-row>
        </el-row>
        <div class="triangle"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  name: "OfflineTimeoutReminder",
  data() {
    return {
      queryForm: {
        deptIds: [],
        plateNum: "",
        personnelName: "",
        propertyOwner: "",
      },
      loading: false,
      deptList: [],
      tableData: [],
      remindData: [],
      remindVisible: false,
      remindPositionVisible: false,
      showInfoWindow: false,
      addressData: [],
      map: null,
      marker: null,
      scale: null,
      vehicleInfoWindow: null,
      location: [],
      limit: 10,
      currentPage: 1,
      total: 0,
      refreshTime: "",
      plateNum: "",
      reminderFrequencySort: 0,
      unstartDurationSort: 0,
      pos: 0,
      spanArr: [],
    };
  },
  created() {
    this.getDeptList();
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    // 处理表格数据得到需要合并的数据
    getSpanArr(data) {
      // 初始化数据
      this.spanArr = [];
      this.pos = 0;
      // data 就是我们从后台拿到的需要合并的表格数据
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          // 第一条数据单独处理spanArr存放  每行需要合并的数据
          this.spanArr.push(1);
          // pos 存放标记需要合并数据成功之后的【spanArr的索引】下标
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].notificationTime === data[i - 1].notificationTime) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex === 0 || columnIndex === 1) {
    //     const _row = this.spanArr[rowIndex];
    //     const _col = _row > 0 ? 1 : 0;
    //     console.log(`rowspan:${_row} colspan:${_col}`);
    //     return {
    //       // [0,0] 表示这一行不显示， [2,1]表示行的合并数
    //       rowspan: _row,
    //       colspan: _col,
    //     };
    //   }
    // },
    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex == 0 || columnIndex == 1 || columnIndex == 2) {
    //     // 第二列开始
    //     // this.handleRemindData(rowCount, columnIndex);
    //     if (this.rowCount == rowIndex) {
    //       return {
    //         rowspan: 0,
    //         colspan: 0,
    //       };
    //     } else {
    //       if (
    //         this.data[rowIndex + 1] &&
    //         this.data[rowIndex + 1].notificationTime ==
    //           this.data[rowIndex].notificationTime
    //       ) {
    //         this.rowCount = rowIndex + 1;
    //         return {
    //           rowspan: 2,
    //           colspan: 1,
    //         };
    //       } else {
    //         return {
    //           rowspan: 1,
    //           colspan: 1,
    //         };
    //       }
    //     }
    //   }
    // },
    resetForm() {
      this.$resetForm(this, "queryForm");
      this.getTableList();
    },
    query() {
      this.getTableList();
    },
    remindRecord(rowData) {
      this.remindVisible = true;
      this.getRemindData(rowData.id);
      // this.getSpanArr(this.remindData);
    },
    refreshOpenMap() {
      let vin = sessionStorage.getItem("remindVin");
      this.getAddress(vin);
    },
    getLocation(rowData) {
      sessionStorage.setItem("remindVin", rowData.vin);
      this.getAddress(rowData.vin);
      this.remindPositionVisible = true;
      // setTimeout(() => {
      //   this.refreshOpenMap();
      // }, 1000);
    },
    async getAddress(vin) {
      let _this = this;
      _this.refreshTime = this.$nowDate();
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/vehicleOfflineRemind/location?vin=" + vin
      );
      if (res.code == 1) {
        this.$nextTick(() => {
          this.initMap();
          if (res.data.longitude == 0 && res.data.latitude == 0) {
            _this.$message.warning("未查询到车辆定位数据!");
          } else {
            if (res.data.longitude && res.data.latitude) {
              this.location = [res.data.longitude, res.data.latitude];
              this.addressData.longitude = res.data.longitude;
              this.addressData.latitude = res.data.latitude;
              this.addressData.address = res.data.address;
              //清理覆盖物
              if (_this.marker) {
                _this.map.remove(_this.marker);
              }
              //创建一个 Marker 实例：
              this.marker = new AMap.Marker({
                position: this.location, //经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              });
              // 创建 infoWindow 实例
              this.vehicleInfoWindow = new AMap.InfoWindow({
                anchor: "bottom-center",
                showShadow: true,
                isCustom: true, //使用自定义窗体
                content: this.$refs.vehicleInfo, //传入 dom 对象，或者 html 字符串
                offset: new AMap.Pixel(8, -40),
              });
              this.showInfoWindow = true;
              this.vehicleInfoWindow.open(this.map, this.location);
              this.map.add(this.marker);
              this.map.setFitView();
              this.map.setZoom(12);
            }
          }
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    getAddr(position) {
      // 确保 geocoder 已初始化
      if (!this.geocoder) {
        console.error("Geocoder 未初始化，请检查插件加载");
        return;
      }
      let _this = this;
      _this.geocoder.getAddress(position, (status, result) => {
        if (status === "complete" && result.regeocode) {
          _this.addressData.address = result.regeocode.formattedAddress;
        } else {
          _this.$message.warning("根据经纬度查询地址失败");
        }
      });
    },
    closeDialog() {
      console.log("closeDialog");
      this.remindPositionVisible = false;
      this.showInfoWindow = false;
      //使用 clearMap 方法删除所有覆盖物
      this.map.clearMap();
    },
    // 初始化地图及地图相关插件
    initMap() {
      this.map = new AMap.Map("remindPosition", {
        resizeEnable: true,
        zoom: 16,
        zooms: [3, 20],
        expandZoomRange: true,
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });

      AMap.plugin("AMap.Geocoder", () => {
        this.geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "全国",
        });
      });
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableList();
    },
    // 未启动时长排序
    noStartTimeSort() {
      this.unstartDurationSort = this.unstartDurationSort == 1 ? 2 : 1;
      this.reminderFrequencySort = 0;
      this.getTableList();
    },
    remindCountSort() {
      this.reminderFrequencySort = this.reminderFrequencySort == 1 ? 2 : 1;
      this.unstartDurationSort = 0;
      this.getTableList();
    },
    async getTableList() {
      let _this = this;
      let obj = {};
      _this.loading = true;
      obj.plateNum = _this.queryForm.plateNum;
      obj.personnelName = _this.queryForm.personnelName;
      obj.propertyOwner = _this.queryForm.propertyOwner;
      if (_this.queryForm.deptIds && _this.queryForm.deptIds.length > 0) {
        obj.deptIds = _this.queryForm.deptIds.join(", ").split(",");
      } else {
        obj.deptIds = _this.queryForm.deptIds;
      }
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      obj.reminderFrequencySort = _this.reminderFrequencySort;
      obj.unstartDurationSort = _this.unstartDurationSort;
      let { data: res } = await _this.$axios.post(
        "/api/vehicle/vehicleOfflineRemind/pageList",
        JSON.stringify(obj)
      );
      if (res.code == 1) {
        _this.loading = false;
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
        _this.currentPage = res.data.currPage;
      }
    },
    async getRemindData(id) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/vehicleOfflineRemind/loadDetails",
        {
          params: { id: id },
        }
      );
      if (res.code == 1) {
        _this.loading = false;
        _this.remindData = res.data;
        _this.plateNum = res.data[0].plateNum;
      }
    },
    async getDeptList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        _this.deptList = res.data;
        // 处理数据
        this.handleAddress(res.data);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // el-cascader 控件 最后一级出现空白 暂无数据 页面
    handleAddress(data) {
      data.forEach((item) => {
        if (item.children.length == 0) {
          item.children = undefined;
        } else {
          this.handleAddress(item.children);
        }
      });
      return data;
    },
  },
};
</script>

<style lang="scss" scoped>
.offlineTimeoutReminder-container {
  height: calc(100% - 76px) !important;
  margin: 20px;

  .input-form-inline {
    padding: 20px 20px 0;
    background: #fff;
  }

  .bottom {
    height: calc(100% - 60px);
    padding: 30px 20px 0;
    background: #fff;
  }

  #remindPosition {
    width: 100%;
    height: 600px;
  }

  .time {
    position: absolute;
    top: 80px;
    left: 40px;
    min-width: 200px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    padding: 20px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.8);

    .refreshTime {
      margin-right: 20px;
      font-size: 16px;
    }
  }

  .table-wrapper {
    .table-body {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 10px;
      }

      .table-top {
        display: flex;
        height: 30px;
        line-height: 30px;
        border: 1px solid #484f54;

        span {
          display: inline-block;
          padding: 0 10px;
          font-weight: 600;
        }

        .table-time {
          flex: 1;
          border-left: 1px solid #484f54;
        }
      }
    }
  }

  ::v-deep .el-cascader__tags {
    width: 62%;
    flex-wrap: nowrap;
  }

  /deep/ .remindDialog {
    .el-dialog {
      width: 46%;
    }
  }

  /deep/ .el-dialog {
    width: 68%;

    .el-dialog__body {
      .infoWindow {
        position: relative;
        width: 220px;
        height: 60px;
        padding: 10px;
        font-size: 12px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.8);

        .triangle {
          position: absolute;
          z-index: -1;
          left: calc(50% - 15px);
          bottom: -7px;
          border-top: 8px solid rgba(255, 255, 255, 0.8);
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          /* 利用滤镜filter，添加投影 */
          filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.2));
        }
      }
    }

    .el-table {
      border: 1px solid #ccc;
    }

    th,
    td {
      border-bottom: 0.5px solid #ccc;
      border-right: 0.5px solid #ccc;
    }
  }
}
</style>
